import API from 'services/api';

export const deleteReservation = (calculationId: string) =>
  API.delete(`api/accommodation/reservation/${calculationId}`);
